import React from "react"

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2147483647,
    pointerEvents: "auto",
}

const popupStyle = {
    background: "#FFFFFF",
    borderRadius: 12,
    padding: "40px 50px",
    textAlign: "center",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    maxWidth: "400px",
    width: "90%",
    pointerEvents: "auto",
}

const iconContainerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    position: "relative",
}

const textStyle = {
    color: "#555555",
    fontSize: "18px",
    fontWeight: 500,
    fontFamily: "Arial, Helvetica, sans-serif",
    margin: 0,
    lineHeight: "1.4",
}

export default function SalesExpiredModal() {
    return (
        <div
            role="status"
            aria-live="polite"
            style={overlayStyle}
        >
            <div
                style={popupStyle}
                onClick={(e) => e.stopPropagation()}
            >
                <div style={iconContainerStyle}>
                    {/* Unauthorized / Shield with X (Access Denied) Icon */}
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="64"
                        height="64"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#DC3545"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        <line x1="15" y1="9" x2="9" y2="15" strokeWidth="2" />
                        <line x1="9" y1="9" x2="15" y2="15" strokeWidth="2" />
                    </svg>
                </div>
                <p style={textStyle}>You are not authorized to sell this product. Please contact sales planning team</p>
            </div>
        </div>
    )
}

